export default {
  'dishEdit.title': '编辑菜品',
  'dishAdd.title': '添加菜品',

  'dishEdit.step1': '步骤1: 给菜品添加菜名和描述',
  'dishEdit.step2': '步骤2: 上传一张图片',
  'dishEdit.step3': '步骤3: 在每个菜单中给菜品选择分类',
  'dishEdit.step4': '步骤4: 在每个菜单中添加价格',
  'dishEdit.step4.prerequisite': '完成步骤3以添加价格',
  'dishEdit.step5': '步骤5: 选择附加选项',
  'dishEdit.step5.prerequisite': '完成步骤3以选择附加选项',
  'dishEdit.step.required': '必填',
  'dishEdit.step2.description': `
    <div>照片参考</div>
    <ul style="margin: 0;">
      <li>分辨率：建议为1920 x 1080像素。</li>
      <li>构图：16:9</li>
      <li>方向：竖构图。</li>
      <li>最小宽度和高度：320 x 320。</li>
      <li>菜品位置应在整个图像居中的四分之三左右（建议最佳位置），菜品图像上下左右四个方向需留白，因为图像上传后在平台显示整个菜品时会显示出方形图像缩略图。</li>
    </ul>
  `,

  'dishEdit.field.name': '菜品英文名',
  'dishEdit.field.foreignName': '菜品中文名',
  'dishEdit.field.posName': 'POS别名',
  'dishEdit.field.kitchenName': '后厨别名',
  'dishEdit.field.kitchenForeignName': '后厨中文别名',
  'dishEdit.field.description': '描述',
  'dishEdit.field.foreignDescription': '中文描述',
  'dishEdit.field.containAlcohol': '含酒精？',
  'dishEdit.field.taxCode': '税务代码',
  'dishEdit.field.code': '自定义码',
  'dishEdit.field.printers': '打印机',
  'dishEdit.field.openPrice': '开价菜',
  'dishEdit.field.price': '价格',
  'dishEdit.field.memberPrice': '会员价',
  'dishEdit.field.pointPrice': '积分价',
  'dishEdit.field.pointPrice.addOnAfter': '积分',
  'dishEdit.field.menu': '菜单',
  'dishEdit.field.category': '分类',
  'dishEdit.field.discount': '折扣',
  'dishEdit.field.tax': '税',
  'dishEdit.excludeDiscount': '免于折扣计算',
  'dishEdit.excludeTax': '免税',
  'dishEdit.field.name.required': '菜品英文名必填',
  'dishEdit.field.foreignName.required': '菜品中文名必填',
  'dishEdit.field.price.required': '价格必填',
  'dishEdit.field.categories.required': '请至少选择任意菜单的一个分类。',
  'dishEdit.field.pointPrice.mustMoreThanZero': `不能为0`,
  'dishEdit.action.uploadPhoto': '上传图片',
  'dishEdit.image.description': '上传图片格式为{fileTypes}; 大小为{fileMaxSize}MB以内',
  'dishEdit.image.tooLargeSize': '图像大小需要为{fileMaxSize}MB以内（越接近{fileMaxSize}MB数值越清晰）',
  'dishEdit.image.tooSmallSize': '图片宽度和高度必须至少为 320 x 320',
  'dishEdit.resolutionAdjusted': '分辨率已调整',
  'dishEdit.viewOriginalPhoto': '查看原图',
  'dishEdit.handleImageFailed': '处理图片失败，请重新操作',
  'dishEdit.wrongFileType': '图片格式只能为{fileTypes}',

  'dishEdit.field.name.placeholder': '如无外文名，请再次输入菜品英文名',
  'dishEdit.field.description.placeholder': '输入菜品描述（此信息将会显示在所有的Chowbus菜单中）',
  'dishEdit.field.posName.placeholder': '点餐页上展示的名字',
  'dishEdit.field.kitchenName.placeholder': '在后厨单和标签上展示的名字',
  'dishEdit.field.weightUnit.placeholder': '单位',

  'dishEdit.action.assignCategories': '选择分类',
  'dishEdit.action.assignCustomizations': '选择附加选项',

  'dishEdit.servicePath': '{servicePath}菜单',
  'dishEdit.price.title': '价格',
  'dishEdit.menuPath': '包含{menuPath}菜单',
  'dishEdit.menuCategory': '{menuName}菜单分类',
  'dishEdit.menuPrice': '{menuName}菜单价格',
  'dishEdit.menuCustomizations': '{menuName}菜单附加选项',
  'dishEdit.menuCustomizations.display.setting.title': '显示方式',
  'dishEdit.menuCustomizations.display.setting.fullview.option': '默认(整页显示)',
  'dishEdit.menuCustomizations.display.setting.compactview.option': '紧凑(显示在底部bar)',

  'dishEdit.category.summary':
    '您可以将这道菜添加到{inHouseMenusCount}个堂食菜单和{chowbusMenusCount}个线上菜单中。在每个菜单中选取此菜品应关联的分类。',
  'dishEdit.customized_properties.summary': '这些附加选项将会被应用于所有的菜单里，但是您可以根据需求更新其中任一菜单',
  'dishEdit.customized_properties.tips':
    '附加选项组的 ‘*’ 表示客户在选购这道菜时需要选择至少一个附加选项。如果您想更改此设置，请访问附加选项页面。',

  'dishEdit.option.required': '选项必选',
  'dishEdit.category.required': '至少选择一个分类',

  'dishEdit.successfullyCreated': '成功创建菜品',
  'dishEdit.successfullyUpdated': '成功更新菜品',

  'dishEdit.field.posName.tooltip': '别名可以是短名或缩写，区分大小写，并在点餐页上展示的名字',
  'dishEdit.field.kitchenName.tooltip': '别名可以是短名或缩写，区分大小写，并在后厨单和标签上展示的名字',
  'dishEdit.field.taxCode.tooltip':
    '税务代码用来识别产品所属的类别的税率，使我们可以为您的顾客更准确地计算出税的金额。',
  'dishEdit.uploadImageInMenuBuilder': '请在<a>菜单编辑器</a>中上传您的菜品照片。',
};
